import { glassOverlay as e, glassSurface as t } from "../../theme/theme.mjs";
import { useMobile as n } from "../../hooks/useMobile.mjs";
import { Popup as r } from "../Popup/Popup.mjs";
import { useMobileSwipe as i } from "../../hooks/useMobileSwipe.mjs";
import "react";
import { css as a, keyframes as o, styled as s } from "styled-components";
import { useTranslation as c } from "@maat/store-i18n";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
import * as d from "@radix-ui/react-dialog";
//#region src/components/Drawer/Drawer.tsx
var f = o`from { opacity: 0; } to { opacity: 1; }`, p = o`from { opacity: 1; } to { opacity: 0; }`, m = {
	right: o`from { transform: translateX(100%); } to { transform: translateX(0); }`,
	left: o`from { transform: translateX(-100%); } to { transform: translateX(0); }`,
	top: o`from { transform: translateY(-100%); } to { transform: translateY(0); }`,
	bottom: o`from { transform: translateY(100%); } to { transform: translateY(0); }`
}, h = {
	right: o`from { transform: translateX(0); } to { transform: translateX(100%); }`,
	left: o`from { transform: translateX(0); } to { transform: translateX(-100%); }`,
	top: o`from { transform: translateY(0); } to { transform: translateY(-100%); }`,
	bottom: o`from { transform: translateY(0); } to { transform: translateY(100%); }`
}, g = s(d.Overlay)`
    position: fixed;
    inset: 0;
    ${e};
    z-index: 1000;
    &[data-state='open'] {
        animation: ${f} ${({ theme: e }) => e.transitions.fast} ease;
    }
    &[data-state='closed'] {
        animation: ${p} ${({ theme: e }) => e.transitions.fast} ease;
    }
`, _ = s(d.Content)`
    position: fixed;
    z-index: 1001;
    ${t};
    display: flex;
    flex-direction: column;
    outline: none;
    overflow: hidden;

    ${({ $side: e, $width: t, $height: n, theme: r }) => {
	switch (e) {
		case "right": return a`
                    top: 0;
                    right: 0;
                    bottom: 0;
                    width: ${t ?? "400px"};
                    border-radius: ${r.radii.xl} 0 0 ${r.radii.xl};
                `;
		case "left": return a`
                    top: 0;
                    left: 0;
                    bottom: 0;
                    width: ${t ?? "400px"};
                    border-radius: 0 ${r.radii.xl} ${r.radii.xl} 0;
                `;
		case "top": return a`
                    top: 0;
                    left: 0;
                    right: 0;
                    height: ${n ?? "320px"};
                    border-radius: 0 0 ${r.radii.xl} ${r.radii.xl};
                `;
		case "bottom": return a`
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: ${n ?? "320px"};
                    border-radius: ${r.radii.xl} ${r.radii.xl} 0 0;
                `;
	}
}}

    &[data-state='open'] {
        animation: ${({ $side: e }) => a`
            ${m[e]} 200ms ease-out
        `};
    }
    &[data-state='closed'] {
        animation: ${({ $side: e }) => a`
            ${h[e]} 200ms ease-in
        `};
    }
`, v = s.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(3)};
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;

    @media (max-width: 640px) {
        padding: ${({ theme: e }) => e.spacing(2)};
    }
`, y = s.div`
    flex: 1;
    overflow-y: auto;
    padding: ${({ theme: e }) => e.spacing(3)};
    /* Solid inset layer over the frosted shell — keeps body content legible. */
    background-color: ${({ theme: e }) => e.colors.card};
    border-radius: ${({ theme: e }) => e.radii.lg};
    margin: 0 ${({ theme: e }) => e.spacing(3)} ${({ theme: e }) => e.spacing(3)};

    /* The margin stacks on top of the padding, so a phone was losing 48px per side to
       chrome before any content rendered. 16px + 8px keeps the inset-card look at a
       third of the cost. */
    @media (max-width: 640px) {
        padding: ${({ theme: e }) => e.spacing(2)};
        margin: 0 ${({ theme: e }) => e.spacing(1)} ${({ theme: e }) => e.spacing(1)};
    }
`, b = s.div`
    display: flex;
    gap: ${({ theme: e }) => e.spacing(2)};
    justify-content: flex-end;
    padding: ${({ theme: e }) => e.spacing(3)};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
    flex-shrink: 0;

    @media (max-width: 640px) {
        padding: ${({ theme: e }) => e.spacing(2)};
    }
`, x = s(d.Title)`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.lg};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.cardForeground};
    margin: 0;
`, S = s(d.Description)`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    margin: 0;
    margin-top: 4px;
`, C = s(d.Close)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    color: ${({ theme: e }) => e.colors.mutedForeground};
    border-radius: ${({ theme: e }) => e.radii.md};
    cursor: pointer;
    transition: all ${({ theme: e }) => e.transitions.fast};
    &:hover {
        background-color: ${({ theme: e }) => e.colors.muted};
        color: ${({ theme: e }) => e.colors.foreground};
    }
`, w = ({ open: e, onOpenChange: t, children: a, title: o, description: s, side: f = "right", width: p, height: m }) => {
	let { t: h } = c("ds"), { isMobile: y } = n(), { onTouchStart: b, onTouchEnd: w } = i({ onSwipe: (e) => {
		e === f && t(!1);
	} });
	return y ? /* @__PURE__ */ l(r, {
		open: e,
		onClose: () => t(!1),
		title: o,
		children: a
	}) : /* @__PURE__ */ l(d.Root, {
		open: e,
		onOpenChange: t,
		children: /* @__PURE__ */ u(d.Portal, { children: [/* @__PURE__ */ l(g, {
			onTouchStart: b,
			onTouchEnd: w
		}), /* @__PURE__ */ u(_, {
			$side: f,
			$width: p,
			$height: m,
			onTouchStart: b,
			onTouchEnd: w,
			children: [(o || s) && /* @__PURE__ */ u(v, { children: [/* @__PURE__ */ u("div", { children: [o && /* @__PURE__ */ l(x, { children: o }), s && /* @__PURE__ */ l(S, { children: s })] }), /* @__PURE__ */ l(C, {
				"aria-label": h("common:actions.close"),
				children: /* @__PURE__ */ l("svg", {
					width: "16",
					height: "16",
					viewBox: "0 0 16 16",
					fill: "none",
					children: /* @__PURE__ */ l("path", {
						d: "M12 4L4 12M4 4l8 8",
						stroke: "currentColor",
						strokeWidth: "1.5",
						strokeLinecap: "round"
					})
				})
			})] }), a]
		})] })
	});
}, T = d.Trigger;
//#endregion
export { w as Drawer, y as DrawerBody, b as DrawerFooter, v as DrawerHeader, T as DrawerTrigger };
